import { isEqual, omit } from 'lodash-es';

export default {
  data() {
    return {
      defaultSortOrder: 'desc',
      defaultSearch: '',
      defaultLayout: 'grid',
      defaultPage: '1',
    };
  },
  computed: {
    defaultFilter() {
      return this.sidebarFilter === 'ASSIGNED' ? 'assigned_from_me' : 'all';
    },
    query() {
      return {
        ...this.$route.query,
        ...this.queryFromRoute(this.$route),
      };
    },
    defaultSort() {
      return this.sidebarFilter === 'TRASH' ? 'deleted_on' : 'updated_on';
    },
  },
  methods: {
    pushQuery(query) {
      if (!isEqual(this.$route.query, query)) {
        this.$router.push({ query });
      }
    },
    queryHasChanged(to, from, exclude = ['layout']) {
      const toQuery = omit(this.queryFromRoute(to), exclude);
      const fromQuery = omit(this.queryFromRoute(from), exclude);
      return !isEqual(toQuery, fromQuery);
    },
    queryFromRoute(route) {
      return {
        filter: route.query.filter || this.defaultFilter,
        sort: route.query.sort || this.defaultSort,
        sortOrder: route.query.sortOrder || this.defaultSortOrder,
        search: route.query.search || this.defaultSearch,
        layout: route.query.layout || this.defaultLayout,
        page: route.query.page || this.defaultPage,
      };
    },
  },
};
